import { MinusIcon } from "@heroicons/react/24/solid";
import Tooltip from "react-tooltip";
const MinusButton = ({
  editStatus = false,
  onClick,
  className = "",
  type = "button",
}) => {
  return (
    <>
      <Tooltip
        place="top"
        effect="solid"
        type="info"
        border={false}
        arrowColor="#3a3b3c"
        // borderColor="#0078d7"
        backgroundColor="#3a3b3c"
        textColor="white"
      />
      <button
        type={type}
        data-tip="Remove"
        data-class="text-xxs whitespace-pre px-0"
        onClick={onClick}
        disabled={editStatus ? true : false}
        // className="flex flex-row text-secondary hover:bg-secondary hover:text-white items-center text-xs font-medium border rounded-full transition duration-500 ease select-none focus:outline-none focus:shadow-outline"
        className={`hover:scale-90 transition duration-500 flex flex-row shadow-md text-white hover:text-secondary 
      bg-secondary hover:bg-white items-center text-xs font-medium border border-red-600 rounded-full transition 
      duration-500 ease  select-none focus:outline-none focus:shadow-outline ${className}`}
      >
        <MinusIcon className="h-4 w-4" />
      </button>
    </>
  );
};
export default MinusButton;
